import React from 'react'
import Icon from '../Icon/index'
import { makeIcon } from '../OracleCommons/icons'

interface OracleSearchInputProps {
  value: string
  onChange: (value: string) => void
  onKeyDown: (e: React.KeyboardEvent) => void
  onClear?: () => void
  placeholder: string
}

export const OracleSearchInput: React.FC<OracleSearchInputProps> = ({
  value,
  onChange,
  onKeyDown,
  onClear,
  placeholder,
}) => {
  return (
    <div className="oracle-search-input">
      <div className="oracle-search-input__icon">
        <Icon color="currentColor" size={20}>
          {makeIcon('search')}
        </Icon>
      </div>
      <input
        type="text"
        className="oracle-search-input__field"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
      />
      {value && (
        <button
          className="oracle-search-input__clear"
          onClick={onClear || (() => onChange(''))}
          type="button"
        >
          <Icon color="currentColor" size={20}>
            {makeIcon('close')}
          </Icon>
        </button>
      )}
    </div>
  )
}
